import { jsx } from "react/jsx-runtime";
import HubIcon from "@mui/icons-material/Hub";
import { validateTidalLicense } from "../../base/index.js";
function Hub(props) {
  return /* @__PURE__ */ jsx(
    HubIcon,
    {
      "data-testid": "Hub",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Hub",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Hub.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Hub"
};
validateTidalLicense();
export {
  Hub
};
//# sourceMappingURL=Hub.js.map
